module.exports = __webpack_public_path__ + "img/earth.6953c7cd.svg";